var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v(" Overview Dashboard ")]),_c('v-card-text',[_c('cash-flow-chart')],1)],1),_c('h2',{staticClass:"pa-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }